import React, { Component } from "react";
import { connect } from "react-redux";
import { FormGroup, Button } from "reactstrap";
import Select from "react-select";
import NetworkTable from "./networkTable";
import Loader from "react-loaders";
import axiosInstance from "../configuration/Request";
import { formatDate } from "../../utils/dateForamt";
import SweetAlert from "react-bootstrap-sweetalert";
import DeleteProject from "./deleteProject";
import EditProject from "./EditProject";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../Components/Toaster";
import "react-toastify/dist/ReactToastify.css";
import {
  setNetworkSuccess,
  setCytoscape,
  setNetworkAnalysis,
  setNetworkAnalysisDetails,
} from "../../reducers/counterSlice";
import { RiDeleteBin6Line } from "react-icons/ri";
import NewProjectModal from "../Popup/NewProjectModal";
import { saveAs } from "file-saver";
import { Link } from "react-router-dom";

const mapStateToProps = (state) => {
  return {
    reduxData: state.counterSlice,
    loginSubscriptionDetail: state.counterSlice.loginSubscriptionDetail,
  };
};

const mapDispatchToProps = {
  setNetworkSuccess,
  setCytoscape,
  setNetworkAnalysis,
  setNetworkAnalysisDetails,
};

class MyProject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'networks', // Default to Networks tab
      selectedCombineNetwork: null,
      networkData: [],
      loader: false,
      CombineNetworkOptions: [
        { value: "Differential Network", label: "Differential Network" },
        { value: "Overlapped Network", label: "Overlapped Network" },
        { value: "Union Network", label: "Union Network" },
      ],
      openDeletePopup: false,
      openEditPopup: false,
      seletedRowForEdit: {},
      seletedRowDelete: [],
      page: 1,
      pageSize: 10,
      pageCount: 0, // total number of pages (from API response)
      total: 0, // total items (from API response)
      selectedNetwork: [],
      isDisabledRun: true,
      operationError: "",
      graphKey: Date.now(),
      intervalId: null,
      showNewProjectModal: false,
      activePlanDetails: {},
    };
  }

  componentWillUnmount() {
    // Clear the interval if the component is unmounted
    if (this.state.intervalId) {
      clearInterval(this.state.intervalId);
    }
    // Ensure body class is removed when component unmounts
    document.body.classList.remove('modal-is-open');
  }

  componentDidMount() {
    // Fetch active plan details
    const loginSubs = this.props?.loginSubscriptionDetail || [];
    const highestIdObject = loginSubs.find(item => item.attributes?.active === true) || { id: 0 };
    this.setState({ activePlanDetails: highestIdObject });

    // Check for active tab in URL
    const searchParams = new URLSearchParams(this.props.location.search);
    const activeTabParam = searchParams.get('activeTab');
    if (activeTabParam && (activeTabParam === 'networks' || activeTabParam === 'projects')) {
      this.setState({ activeTab: activeTabParam });
      if (activeTabParam === 'networks') {
        this.fetchNetworkTableDetails(this.state.page, this.state.pageSize);
      } else {
        this.fetchProjectsTableDetails(this.state.page, this.state.pageSize);
      }
    } else {
      this.fetchNetworkTableDetails(this.state.page, this.state.pageSize);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Debug: Check ALL state changes
    Object.keys(this.state).forEach(key => {
      if (prevState[key] !== this.state[key]) {
        console.log(`🟡 STATE CHANGE: ${key}  changed from`, prevState[key], 'to', this.state[key]);
      }
    });
  }

  fetchNetworkTableDetails = (page, pageSize, isPolling = false) => {
    axiosInstance
      .get(
        `${process.env.REACT_APP_BASE_URL}api/new-networks?pagination[page]=${page}&pagination[pageSize]=${pageSize}`
      )
      .then((res) => {
        const networks = res?.data?.data?.map((item) => ({
          id: item?.id,
          status: item.attributes?.status ? item.attributes?.status : "-",
          networkName: item?.attributes?.project_name
            ? item?.attributes?.project_name
            : "-",
          submitTime: item?.attributes?.createdAt
            ? formatDate(item?.attributes?.createdAt)
            : "-",
          network_type: item.attributes?.network_type,
          cancer_type: item.attributes?.cancer_type,
          histological_subtype: item.attributes?.histological_subtype,
          view_network: item.attributes?.view_network,
        }));

        const newState = { networkData: networks };

        // If it's not a polling request, update pagination and other states
        if (!isPolling) {
          Object.assign(newState, {
            page: res?.data?.meta?.pagination?.page,
            pageSize: res?.data?.meta?.pagination?.pageSize,
            pageCount: res?.data?.meta?.pagination?.pageCount,
            total: res?.data?.meta?.pagination?.total,
            selectedNetwork: [],
            selectedCombineNetwork: null,
          });
        }

        // Only update state if the active tab is still 'networks'
        // This prevents network polling data from overwriting project data if the user switched tabs
        if (this.state.activeTab === 'networks') {
          this.setState(newState, this.checkAndPollRunningStatus);
        } else {
          // If the user has switched tabs, clear any running interval
          if (this.state.intervalId) {
            clearInterval(this.state.intervalId);
            this.setState({ intervalId: null });
          }
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) return;
        if (!isPolling) {
          if (err?.response?.data?.error?.message) {
            showErrorToast(err?.response?.data?.error?.message, false);
          } else {
            showErrorToast("Error while fetching network", false);
          }
        }
      })
      .finally(() => {
        this.setState({ loader: false });
        if (!isPolling && this.props.reduxData.networkSuccess) {
          showSuccessToast("Network created successfully!");
          this.props.setNetworkSuccess(false);
        }
      });
  };

  fetchProjectsTableDetails = (page, pageSize) => {
    this.setState({ loader: true });
    axiosInstance
      .get(
        `${process.env.REACT_APP_BASE_URL}api/gene-lists?pagination[page]=${page}&pagination[pageSize]=${pageSize}`
      )
      .then((res) => {
        const projects = res?.data?.data?.map((item) => ({
          id: item?.id,
          status: "Done", // Projects don't have status, default to Done for action buttons
          networkName: item?.attributes?.project_name
            ? item?.attributes?.project_name
            : "-",
          submitTime: item?.attributes?.createdAt
            ? formatDate(item?.attributes?.createdAt)
            : "-",
          view_network: item.attributes?.view_network !== undefined ? item.attributes?.view_network : false,
        }));

        this.setState({
          networkData: projects,
          page: res?.data?.meta?.pagination?.page,
          pageSize: res?.data?.meta?.pagination?.pageSize,
          pageCount: res?.data?.meta?.pagination?.pageCount,
          total: res?.data?.meta?.pagination?.total,
          selectedNetwork: [],
          selectedCombineNetwork: null,
        });
      })
      .catch((err) => {
        if (err?.response?.status === 401) return;
        if (err?.response?.data?.error?.message) {
          showErrorToast(err?.response?.data?.error?.message, false);
        } else {
          showErrorToast("Error while fetching projects", false);
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  checkAndPollRunningStatus = () => {
    // Only poll if the Network tab is active
    if (this.state.activeTab !== 'networks') {
      if (this.state.intervalId) {
        clearInterval(this.state.intervalId);
        this.setState({ intervalId: null });
      }
      return;
    }

    // Check if any network has a status of "Running"
    const hasRunning = this.state.networkData.some(
      (network) => network.status === "Running"
    );

    if (hasRunning && !this.state.intervalId) {
      // Start polling if there's no interval running
      const intervalId = setInterval(() => {
        // Double check tab before calling API
        if (this.state.activeTab === 'networks') {
          this.fetchNetworkTableDetails(
            this.state.page,
            this.state.pageSize,
            true
          );
        } else {
          // Clear interval if tab changed
          clearInterval(this.state.intervalId);
          this.setState({ intervalId: null });
        }
      }, 5000);

      this.setState({ intervalId });
    } else if (!hasRunning && this.state.intervalId) {
      clearInterval(this.state.intervalId);
      this.setState({ intervalId: null });
    }
  };

  errorHandling = (selectedNetwork, combineNetwork) => {
    if (
      selectedNetwork.length > 0 &&
      selectedNetwork.length < 2 &&
      combineNetwork
    ) {
      this.setState({
        operationError:
          "Please select atleast two networks to perform operation",
      });
    } else if (selectedNetwork.length > 2 && combineNetwork) {
      this.setState({
        operationError: "Please select only two networks to perform operation",
      });
    } else {
      this.setState({
        operationError: "",
      });
    }
  };

  handleChange = (event) => {
    this.setState({ selectedCombineNetwork: event });
    this.errorHandling(this.state.selectedNetwork, event);
  };

  handheNewNetwork = () => {
    this.props.setNetworkAnalysisDetails({});
    this.props.history.push("/app/discover/newNetwork");
  };

  handheRunOperations = () => {
    if (!this.state.selectedCombineNetwork) {
      this.setState({
        operationError: "Please select network operation dropdown value",
      });
      return;
    }
    let payload = {
      input_file_1: this.state.selectedNetwork[0].id,
      input_file_2: this.state.selectedNetwork[1].id,
      operation_type: this.state.selectedCombineNetwork?.value,
    };
    this.setState({ loader: true });
    axiosInstance
      .post(process.env.REACT_APP_BASE_URL + `api/network-operations`, payload)
      .then((response) => {
        this.fetchNetworkTableDetails(this.state.page, this.state.pageSize);
        this.setState({ graphKey: Date.now() });
        showSuccessToast("Combination network created successfully!");
      })
      .catch((error) => {
        if (error?.response?.status === 401) return;
        if (error?.response?.data?.error?.message) {
          showErrorToast(error.response.data.error.message);
        } else {
          showErrorToast(
            "Something went wrong.Not able to create combination networks."
          );
        }
      })
      .finally(() => {
        this.setState({ loader: false });
      });
  };

  // handleDownload = (rowData) => {
  //   this.setState({ loader: true });
  //   axiosInstance
  //     .get(`${process.env.REACT_APP_BASE_URL}api/download?id=${rowData.id}`)
  //     .then((res) => {
  //       fetch(res?.data?.downloadUrl)
  //         .then((response) => response.blob())
  //         .then((blob) => {
  //           saveAs(blob,  rowData.networkName);
  //           this.setState({ loader: false });
  //         })
  //         .catch((error) => {
  //           console.error("Error downloading file:", error);
  //           showErrorToast("Error downloading file");
  //           this.setState({ loader: false });
  //         });
  //     })
  //     .catch((err) => {
  //       showErrorToast("Error while downloading network");
  //     })
  //     .finally(() => {
  //       this.setState({ loader: false });
  //     });
  // };

  handleDownload = (rowData) => {
    this.setState({ loader: true });

    // Use different API endpoints based on active tab
    const apiUrl = this.state.activeTab === 'projects'
      ? `${process.env.REACT_APP_BASE_URL}api/gene-lists/download?id=${rowData.id}`
      : `${process.env.REACT_APP_BASE_URL}api/download?id=${rowData.id}`;

    axiosInstance
      .get(apiUrl)
      .then((res) => {
        const downloadUrl = res?.data?.downloadUrl;
        if (!downloadUrl) {
          showErrorToast(res?.error || "Download URL not available");
          this.setState({ loader: false });
          return;
        }

        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${rowData.networkName}.csv`; // set a default
        document.body.appendChild(link);
        link.click();
        link.remove();

        this.setState({ loader: false });
      })
      .catch((err) => {
        if (err?.response?.status === 401) return;
        console.error("API error while generating download link:", err.response?.data?.error);
        showErrorToast(err.response?.data?.error || "Error downloading file");
        this.setState({ loader: false });
      });
  };



  handleEditEvent = (rowData) => {
    this.setState({ seletedRowForEdit: rowData, openEditPopup: true });
  };

  handleMultiDelete = () => {
    const selectedIds = this.state.selectedNetwork.map((element) => element.id);
    this.setState({ seletedRowDelete: selectedIds, openDeletePopup: true });
  };

  handleDeleteEvent = (rowData) => {
    this.setState({
      seletedRowDelete: [rowData.id],
      openDeletePopup: true,
      operationError: "",
    });
  };

  handleDeleteEditSuccess = (action) => {
    const message =
      action === "delete"
        ? "Network deleted successfully"
        : `Network name updated successfully`;
    this.setState({
      seletedRowForEdit: {},
      seletedRowDelete: [],
      openDeletePopup: false,
      openEditPopup: false,
    });
    if (action === "delete") {
      this.setState({ graphKey: Date.now() });
    }

    showSuccessToast(message);

    // Call appropriate fetch method based on active tab
    if (this.state.activeTab === 'networks') {
      this.fetchNetworkTableDetails(this.state.page, this.state.pageSize);
    } else if (this.state.activeTab === 'projects') {
      this.fetchProjectsTableDetails(this.state.page, this.state.pageSize);
    }
  };

  closePopup = () => {
    this.setState({
      seletedRowForEdit: {},
      seletedRowDelete: [],
      openDeletePopup: false,
      openEditPopup: false,
    });
  };

  handleView = (rowData) => {
    this.props.setCytoscape({
      cytoscapeID: rowData.id,
      isFromProject: this.state.activeTab === 'projects',
    });
    this.props.history.push(
      `/app/discover/viewNetwork?activeTab=${this.state.activeTab}`
    );
  };

  handleAnalysis = (rowData) => {
    this.props.setCytoscape({
      cytoscapeID: rowData.id,
    });
    this.props.setNetworkAnalysis({
      networkId: rowData.id,
      networkType: rowData.network_type,
      cancerType: rowData.cancer_type,
      histologicalSubtype: rowData.histological_subtype,
      isFromProject: this.state.activeTab === 'projects', // Flag for Project table
    });
    this.props.history.push(
      `/app/discover/furtherAnalysis?activeTab=${this.state.activeTab}`
    );
  };

  rowSelectionHandler = (selectedRow) => {
    this.setState({
      selectedNetwork: selectedRow?.selectedRows,
      operationError: "",
    });
    if (selectedRow?.selectedRows.length <= 0) {
      this.setState({ selectedCombineNetwork: null, operationError: "" });
    }
    this.errorHandling(
      selectedRow?.selectedRows,
      this.state.selectedCombineNetwork
    );
  };

  handlePageChange = (page) => {
    this.setState({ page });
    if (this.state.activeTab === 'networks') {
      this.fetchNetworkTableDetails(page, this.state.pageSize);
    } else if (this.state.activeTab === 'projects') {
      this.fetchProjectsTableDetails(page, this.state.pageSize);
    }
  };

  handleRowsPerPageChange = (newPerPage) => {
    this.setState({ pageSize: newPerPage, page: 1 }, () => {
      if (this.state.activeTab === 'networks') {
        this.fetchNetworkTableDetails(1, newPerPage);
      } else if (this.state.activeTab === 'projects') {
        this.fetchProjectsTableDetails(1, newPerPage);
      }
    });
  };

  toggleNewProjectModal = () => {
    this.setState(
      (prevState) => ({
        showNewProjectModal: !prevState.showNewProjectModal,
      }),
      () => {
        // If closing, remove body class
        if (!this.state.showNewProjectModal) {
          document.body.classList.remove("modal-is-open");
        }
      }
    );
  };

  handleTabChange = (tab) => {
    this.setState(
      {
        activeTab: tab,
        page: 1,
        networkData: [],
        selectedNetwork: [],
        selectedCombineNetwork: null,
        operationError: "",
        loader: true, // Show loader when switching tabs
      },
      () => {
        // Clear any polling interval when switching tabs
        if (this.state.intervalId) {
          clearInterval(this.state.intervalId);
          this.setState({ intervalId: null });
        }

        // Fetch data based on active tab
        if (tab === 'networks') {
          this.fetchNetworkTableDetails(1, this.state.pageSize);
        } else if (tab === 'projects') {
          this.fetchProjectsTableDetails(1, this.state.pageSize);
        }
      }
    );
  };

  render() {
    const { selectedCombineNetwork, operationError, activePlanDetails, activeTab } = this.state;
    const isDisabled = this.state.selectedNetwork.length <= 0;
    const isDisabledRun = this.state.selectedNetwork.length !== 2;
    return (
      <div className="network-container-outer">
        {activePlanDetails?.attributes?.plan?.toLowerCase() === 'bronze' && (
          <div className="bronze-upgrade-notice">
            <div className="d-flex align-items-center">
              <div className="upgrade-notice-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="12" cy="12" r="10" fill="#5460D1" />
                  <path d="M12 8V12M12 16H12.01" stroke="white" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </div>
              <div className="upgrade-notice-content">
                <strong>Free Plan Upgrade Notice:</strong> You are currently on the Free plan. Upgrade to unlock more project features and full data access.
              </div>
            </div>
            <Link
              to={{
                pathname: '/app/profileEdit',
                state: { param: 'billing' }
              }}
            >
              <Button className="upgrade-notice-button" color="primary">
                Subscribe Now
              </Button>
            </Link>
          </div>
        )}
        <div className="network-container">
          <ToastContainer />

          {/* Tab Navigation */}
          <div className="tabs-container" style={{ marginBottom: '20px' }}>
            <div className="tabs-header" style={{ display: 'flex', borderBottom: '2px solid #e0e0e0' }}>
              <button
                className={`tab-button ${activeTab === 'networks' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('networks')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === 'networks' ? 'bold' : 'normal',
                  color: activeTab === 'networks' ? '#5460D1' : '#666',
                  borderBottom: activeTab === 'networks' ? '3px solid #5460D1' : '3px solid transparent',
                  marginBottom: '-2px',
                  transition: 'all 0.3s ease'
                }}
              >
                Networks
              </button>
              <button
                className={`tab-button ${activeTab === 'projects' ? 'active' : ''}`}
                onClick={() => this.handleTabChange('projects')}
                style={{
                  padding: '12px 24px',
                  border: 'none',
                  background: 'none',
                  cursor: 'pointer',
                  fontSize: '16px',
                  fontWeight: activeTab === 'projects' ? 'bold' : 'normal',
                  color: activeTab === 'projects' ? '#5460D1' : '#666',
                  borderBottom: activeTab === 'projects' ? '3px solid #5460D1' : '3px solid transparent',
                  marginBottom: '-2px',
                  transition: 'all 0.3s ease'
                }}
              >
                Projects
              </button>
            </div>
          </div>

          {/* Title and Create Button */}
          <div className="top-div flex-wrap">
            <div className="title-div fw-bold">
              {activeTab === 'networks' ? 'Networks' : 'Projects'}
            </div>
            <div className="flex-wrap">
              {activeTab === 'networks' ? (
                <Button
                  className="create-button-parameter"
                  color="primary"
                  onClick={this.handheNewNetwork}
                >
                  Create New Network
                </Button>
              ) : (
                <Button
                  className="create-button-parameter me-2"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    document.body.classList.add("modal-is-open");
                    this.setState({ showNewProjectModal: true });
                  }}
                >
                  Create project
                </Button>
              )}
            </div>
          </div>

          {/* Network Operations - Only show for Networks tab */}
          {activeTab === 'networks' && (
            <div className="network-button-container">
              <FormGroup className="select-dropdown-network">
                <Select
                  styles={{
                    control: (baseStyles) => ({
                      ...baseStyles,
                      cursor: "pointer",
                    }),
                    option: (base) => ({
                      ...base,
                      cursor: "pointer",
                    }),
                  }}
                  value={selectedCombineNetwork}
                  onChange={this.handleChange}
                  options={this.state.CombineNetworkOptions}
                  placeholder="Network Operations"
                  isDisabled={isDisabled}
                />
              </FormGroup>
              <Button
                className="combine-network-button"
                color="primary"
                disabled={isDisabledRun}
                onClick={this.handheRunOperations}
              >
                Run Operations
              </Button>
              <Button
                className=" delete-button-div"
                color="danger"
                onClick={this.handleMultiDelete}
                disabled={this.state.selectedNetwork.length <= 0}
              >
                <RiDeleteBin6Line size={18} />
              </Button>
            </div>
          )}

          {/* Delete Button - Show for Projects tab */}
          {activeTab === 'projects' && (
            <div className="network-button-container">
              <Button
                className=" delete-button-div"
                color="danger"
                onClick={this.handleMultiDelete}
                disabled={this.state.selectedNetwork.length <= 0}
              >
                <RiDeleteBin6Line size={18} />
              </Button>
            </div>
          )}

          {/* Error Message */}
          <div className="error-message-operation">
            {operationError && (
              <div className="text-danger">{operationError}</div>
            )}
          </div>

          {/* Table - Single table with conditional props */}
          <div className="network-table">
            <NetworkTable
              key={this.state.graphKey}
              networkDetails={this.state.networkData}
              onEdit={this.handleEditEvent}
              onDelete={this.handleDeleteEvent}
              onView={this.handleView}
              onAnalysisClick={this.handleAnalysis}
              onDownload={this.handleDownload}
              handleRowSelection={this.rowSelectionHandler}
              page={this.state.page}
              pageSize={this.state.pageSize}
              pageCount={this.state.pageCount}
              total={this.state.total}
              onPageChange={this.handlePageChange}
              onRowsPerPageChange={this.handleRowsPerPageChange}
              showStatusColumn={activeTab === 'networks'}
              showViewButton={true}
              activeTab={activeTab}
            />
          </div>

          {/* Loader */}
          {this.state.loader && (
            <div className="backdrop">
              <div className="loader">
                <Loader type="ball-pulse-rise" />
              </div>
            </div>
          )}

          {/* Edit Popup */}
          <SweetAlert
            custom
            show={this.state.openEditPopup}
            customButtons={<React.Fragment></React.Fragment>}
            style={{ width: "auto", padding: "1rem" }}
          >
            <EditProject
              closeAlert={this.closePopup}
              onEditHandler={this.handleDeleteEditSuccess}
              networkData={this.state.seletedRowForEdit}
              isProjectTab={this.state.activeTab === 'projects'}
            ></EditProject>
          </SweetAlert>

          {/* Delete Popup */}
          <SweetAlert
            custom
            show={this.state.openDeletePopup}
            customButtons={<React.Fragment></React.Fragment>}
            style={{ width: "auto", padding: "1rem" }}
          >
            <DeleteProject
              closeAlert={this.closePopup}
              onDeleteHandler={this.handleDeleteEditSuccess}
              deleteIdArray={this.state.seletedRowDelete}
              isProjectTab={this.state.activeTab === 'projects'}
            ></DeleteProject>
          </SweetAlert>

          {/* New Project Modal */}
          <NewProjectModal
            isOpen={this.state.showNewProjectModal}
            toggle={this.toggleNewProjectModal}
            onSuccess={(data) => {
              console.log("New project created:", data);
              if (this.state.activeTab === 'projects') {
                this.fetchProjectsTableDetails(this.state.page, this.state.pageSize);
              } else {
                this.fetchNetworkTableDetails(this.state.page, this.state.pageSize);
              }
            }}
          />
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MyProject);
